export default "__VITE_ASSET__4e1bd87d__"